<template>
  <div>
    <new-category :form_id="form.id" @created="getCategories(true)" />

    <modify-category
      :form_id="form.id"
      :category_id="current_category_id"
      :editable="form.status_value == 'OPEN'"
      @updated="getCategories"
    />

    <new-question
      :form_id="form.id"
      :category_id="current_category_id"
      @created="getCategories"
    />

    <modify-question
      :form_id="form.id"
      :category_id="current_category_id"
      :question_id="current_question_id"
      :editable="form.status_value == 'OPEN'"
      @updated="getCategories"
    />

    <div>
      <div class="row">
        <div
          class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 check-text-center"
        >
          <h4 class="my-0">CATEGORIA E PERGUNTA</h4>
        </div>

        <div
          class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 check-text-right"
        >
          <!-- entrar e salvar reordernação -->
          <v-btn
            class="btn-reordenar-save m-1"
            v-show="
              form.status_value == 'OPEN' && !reorder_mode && allowReorderMode()
            "
            @click.stop="reorderMode"
          >
            <i class="fas fa-sort text-twenty mr-2"></i> REORDENAR
          </v-btn>

          <v-btn
            v-show="form.status_value == 'OPEN' && !reorder_mode"
            class="btn-add ml-2"
            @click.prevent="$bvModal.show('new_category')"
          >
            <i class="fas fa-plus text-twenty mr-2" /> NOVA CATEGORIA
          </v-btn>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <v-expansion-panels mandatory accordion hover class="border">
            <v-expansion-panel
              v-for="(category, category_index) in categories"
              :key="category.id"
            >
              <v-expansion-panel-header>
                <div class="row align-items-center">
                  <div class="col-12 d-flex justify-content-between">
                    <h6 class="upper-text worksansr pt-1 mb-0">
                      CATEGORIA:
                      <strong class="upper-text">{{ category.name }}</strong>
                    </h6>

                    <h6 class="upper-text worksansr pt-1 mb-0 text-end">
                      TIPO:
                      <div v-if="category.public == 1">
                        <i class="fas fa-users mr-2"></i>

                        <strong>Pública</strong>
                      </div>

                      <div v-else>
                        <i class="fas fa-user mr-2"></i>

                        <strong>Privada</strong>
                      </div>
                    </h6>
                  </div>

                  <div
                    class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 check-text-right"
                  >
                    <v-btn
                      v-show="
                        form.status_value == 'OPEN' &&
                        reorder_mode &&
                        category_index > 0
                      "
                      class="btn-reordenar mr-5"
                      small
                      :disabled="loading"
                      @click.stop="reorderCategory(category_index, -1)"
                    >
                      <i class="fas fa-arrow-up text-thirteen"></i>
                    </v-btn>

                    <v-btn
                      v-show="
                        form.status_value == 'OPEN' &&
                        reorder_mode &&
                        category_index < categories.length - 1
                      "
                      class="btn-reordenar mr-5"
                      small
                      :disabled="loading"
                      @click.stop="reorderCategory(category_index, 1)"
                    >
                      <i class="fas fa-arrow-down text-thirteen"></i>
                    </v-btn>

                    <confirmation-dialog
                      v-show="form.status_value == 'OPEN' && !reorder_mode"
                      :disabled="loading"
                      small
                      message-title="Confirmar"
                      message-body="Tem certeza que deseja remover esta categoria?"
                      open-text="EXCLUIR"
                      open-class="btn-delete m-1"
                      yes-class="btn-delete"
                      open-left-icon="fa-trash mr-2"
                      @yes="removeCategory(category.id)"
                    />

                    <v-btn
                      v-show="form.status_value == 'OPEN' && !reorder_mode"
                      class="btn-edit m-1"
                      small
                      @click.stop="openModifyCategory(category.id)"
                    >
                      <i class="fas fa-pencil-alt mr-2 text-twenty" />
                      EDITAR
                    </v-btn>

                    <v-btn
                      v-show="form.status_value == 'OPEN' && !reorder_mode"
                      class="btn-two-add m-1"
                      small
                      @click.stop="openNewQuestion(category.id)"
                    >
                      <i class="fas fa-plus mr-2 text-twenty"></i>
                      ADICIONAR PERGUNTA
                    </v-btn>
                  </div>
                </div>
              </v-expansion-panel-header>

              <v-expansion-panel-content class="p-0">
                <errors-messages :errors="errors" />

                <h6 class="back-ground-grey p-2 upper-text">Perguntas:</h6>

                <v-expansion-panels accordion flat hover class="p-0">
                  <v-expansion-panel
                    v-for="(question, question_index) in category.questions"
                    :key="question.id"
                    class="p-0"
                  >
                    <v-expansion-panel-header>
                      <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                          <h6>
                            {{ question_index + 1 }}. {{ question.statement }}
                          </h6>

                          <div
                            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
                          >
                            <div class="row">
                              <h6
                                class="color-blue text-twelve mr-3 border p-1"
                              >
                                {{ question.type_name }}
                              </h6>

                              <h6
                                v-show="question.mandatory"
                                class="color-red text-twelve border p-1"
                              >
                                OBRIGATÓRIA
                              </h6>
                            </div>

                            <div v-if="category.public == 0" class="mt-2">
                              <span
                                class="worksansr font-weight-bold text-secondary mb-1 d-block"
                              >
                                Perfis vinculados:
                              </span>

                              <div class="d-flex flex-wrap gap-2 mt-1">
                                <span
                                  v-for="profile_name in category.linked_profile_name"
                                  :key="profile_name"
                                  class="badge bg-primary text-white me-2 mb-1"
                                >
                                  {{ profile_name }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 check-text-right mt-4"
                        >
                          <v-btn
                            v-show="
                              form.status_value == 'OPEN' &&
                              reorder_mode &&
                              question_index > 0
                            "
                            class="btn-reordenar mr-5"
                            small
                            :disabled="loading"
                            @click.stop="
                              reorderQuestion(
                                category_index,
                                question_index,
                                -1
                              )
                            "
                          >
                            <i class="fas fa-arrow-up text-thirteen"></i>
                          </v-btn>

                          <v-btn
                            v-show="
                              form.status_value == 'OPEN' &&
                              reorder_mode &&
                              question_index < category.questions.length - 1
                            "
                            class="btn-reordenar mr-5"
                            small
                            :disabled="loading"
                            @click.stop="
                              reorderQuestion(category_index, question_index, 1)
                            "
                          >
                            <i class="fas fa-arrow-down text-thirteen"></i>
                          </v-btn>

                          <v-btn
                            v-show="
                              form.status_value == 'OPEN' && !reorder_mode
                            "
                            class="btn-edit mr-1"
                            small
                            @click.stop="
                              openModifyQuestion(category.id, question.id)
                            "
                          >
                            <i class="fas fa-pencil-alt mr-2 text-twenty"></i>
                            EDITAR
                          </v-btn>

                          <confirmation-dialog
                            v-show="
                              form.status_value == 'OPEN' && !reorder_mode
                            "
                            :disabled="loading"
                            small
                            message-title="Confirmar"
                            message-body="Tem certeza que deseja remover esta pergunta?"
                            open-text="EXCLUIR"
                            open-class="btn-delete mr-2"
                            open-left-icon="fa-trash mr-2"
                            @yes="removeQuestion(category.id, question.id)"
                          />

                          <div
                            class="switch-container"
                            v-show="form.status_value != 'OPEN'"
                          >
                            <span
                              class="worksansr font-weight-bold text-secondary mb-1 d-block"
                              >Copiar resposta no próximo formulário:
                            </span>

                            <label class="switch-modern">
                              <input
                                type="checkbox"
                                v-model="question.copy_answer_next_form"
                                :disabled="loading"
                                @change="
                                  updateDuplicateAnswer(
                                    question.id,
                                    question.copy_answer_next_form
                                  )
                                "
                              />

                              <span class="slider-modern">
                                <span class="slider-thumb">
                                  <i class="fas fa-check thumb-icon"></i>
                                </span>
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <template v-if="question.type_value != 'OPEN'">
                        <h6 class="mt-1">ALTERNATIVAS:</h6>

                        <div
                          v-for="(
                            alternative, alternative_index
                          ) in question.alternatives"
                          :key="alternative.id"
                          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0 pt-0"
                        >
                          <div class="row">
                            <div
                              class="col-xl-10 col-lg-10 col-md-10 col-sm-8 col-12 pb-0 pt-0"
                            >
                              <ul class="m-0">
                                <li class="mt-3">
                                  {{ alternative.label }}
                                </li>
                              </ul>
                            </div>
                            <div
                              class="col-xl-2 col-lg-2 col-md-2 col-sm-4 col-12 pb-0 pt-0 text-right"
                            >
                              <v-btn
                                v-show="
                                  form.status_value == 'OPEN' &&
                                  reorder_mode &&
                                  alternative_index > 0
                                "
                                class="btn-reordenar m-2"
                                small
                                :disabled="loading"
                                @click.stop="
                                  reorderAlternative(
                                    category_index,
                                    question_index,
                                    alternative_index,
                                    -1
                                  )
                                "
                              >
                                <i class="fas fa-arrow-up text-thirteen"></i>
                              </v-btn>

                              <v-btn
                                v-show="
                                  form.status_value == 'OPEN' &&
                                  reorder_mode &&
                                  alternative_index <
                                    question.alternatives.length - 1
                                "
                                class="btn-reordenar m-2"
                                small
                                :disabled="loading"
                                @click.stop="
                                  reorderAlternative(
                                    category_index,
                                    question_index,
                                    alternative_index,
                                    1
                                  )
                                "
                              >
                                <i class="fas fa-arrow-down text-thirteen"></i>
                              </v-btn>
                            </div>
                          </div>

                          <hr class="mt-1 mb-0" />
                        </div>
                      </template>

                      <template v-if="question.type_value == 'OPEN'">
                        <h6 class="worksansr pt-5 text-thirteen upper-text">
                          As perguntas abertas são aquelas que permitem qualquer
                          tipo de resposta. Elas não delimitam ou restrigem a
                          opções.
                        </h6>
                      </template>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>

      <b-row align-h="end">
        <b-col cols="auto">
          <v-btn
            class="btn-cancel m-1"
            v-show="form.status_value == 'OPEN' && reorder_mode"
            @click.stop="reorderCancel"
          >
            CANCELAR
          </v-btn>

          <v-btn
            class="btn-reordenar-save m-1"
            v-show="form.status_value == 'OPEN' && reorder_mode"
            @click.stop="reorderSave"
          >
            <i class="fas fa-sort text-twenty mr-2"></i> SALVAR
          </v-btn>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";
import NewCategory from "./NewCategory";
import ModifyCategory from "./ModifyCategory";
import NewQuestion from "./NewQuestion";
import ModifyQuestion from "./ModifyQuestion";
import toast from "../../lib/ToastNotification";
import ErrorsMessages from "../Components/ErrorsMessages";
import ConfirmationDialog from "../Components/ConfirmationDialog";
import { arraySwapItemPosition } from "../../lib/functions";

export default {
  name: "Categories",
  components: {
    NewCategory,
    ModifyCategory,
    NewQuestion,
    ModifyQuestion,
    ErrorsMessages,
    ConfirmationDialog,
  },
  props: {
    /** @type {{
     *  name: string,
     *  description: string,
     *  rest_home_id: number,
     *  id: number,
     *  semiology_form_status_id: number,
     *  status_name: ("ABERTO"|"DISPONÍVEL"|"DESATIVADO"),
     *  status_value: ("OPEN"|"AVAILABLE"|"INACTIVE"),
     *  created_at: Date,
     *  updated_at: Date,
     *  profiles: { id: number, name: string }[],
     *  residents: { id: number, name: string }[],
     *}} formulário
     */
    form: Object,
  },
  data() {
    return {
      errors: [],

      categories: [],

      copy_answer_next_form: false,

      loading: false,

      reorder_mode: false,

      current_category_id: null,

      current_question_id: null,

      current_alternative_id: null,

      current_category_index: 0,
    };
  },
  watch: {
    form: function (form) {
      if (form.id) this.getCategories();
    },
  },

  methods: {
    async getCategories(openLastCategory = false) {
      try {
        this.loading = true;

        const params = { form_id: this.form.id };
        const response = await api.get("/rest-home/semiology/form/categories", {
          params,
        });
        const { error, errors, categories } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.categories = categories;
          if (openLastCategory) {
            setTimeout(() => {
              this.current_category_index = this.categories.length - 1;
            }, 100);
          }
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async updateDuplicateAnswer(id, copy_answer_next_form) {
      try {
        this.loading = true;

        let params = { id, copy_answer_next_form };

        const response = await api.put(
          "/rest-home/semiology/form/category/question",
          params
        );

        const { error, message } = response.data;

        if (!error) {
          toast(message, "success");
        } else {
          toast(message, "error");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    async removeCategory(category_id) {
      try {
        this.loading = true;

        const params = {
          form_id: this.form.id,
          category_id,
        };
        const response = await api.delete(
          "/rest-home/semiology/form/category",
          { params }
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.getCategories();
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async removeQuestion(category_id, question_id) {
      try {
        this.loading = true;

        const params = {
          form_id: this.form.id,
          category_id,
          question_id,
        };
        const response = await api.delete(
          "/rest-home/semiology/form/category/question",
          { params }
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.getCategories();
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async removeAlternative(category_id, question_id, alternative_id) {
      try {
        this.loading = true;

        const params = {
          form_id: this.form.id,
          category_id,
          question_id,
          alternative_id,
        };
        const response = await api.delete(
          "/rest-home/semiology/form/category/question/alternative",
          { params }
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.getCategories();
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async reorderMode() {
      this.reorder_mode = true;
      this.$emit("toggle-reorder-mode", true);
    },

    async reorderCategory(category_index, direction) {
      this.categories = arraySwapItemPosition(
        this.categories,
        category_index,
        category_index + direction
      );
    },

    async reorderQuestion(category_index, question_index, direction) {
      this.categories[category_index].questions = arraySwapItemPosition(
        this.categories[category_index].questions,
        question_index,
        question_index + direction
      );
    },

    async reorderAlternative(
      category_index,
      question_index,
      alternative_index,
      direction
    ) {
      this.categories[category_index].questions[question_index].alternatives =
        arraySwapItemPosition(
          this.categories[category_index].questions[question_index]
            .alternatives,
          alternative_index,
          alternative_index + direction
        );
    },

    async reorderCancel() {
      this.reorder_mode = false;
      this.$emit("toggle-reorder-mode", false);
      this.getCategories(false);
    },

    async reorderSave() {
      try {
        this.loading = true;

        const categories = this.categories.map((category) => ({
          category_id: category.id,
          questions: category.questions.map((question) => ({
            question_id: question.id,
            alternatives: question.alternatives.map(
              (alternative) => alternative.id
            ),
          })),
        }));
        const data = { form_id: this.form.id, categories };
        const response = await api.patch(
          "/rest-home/semilogy/form/reorder",
          data
        );
        const { error, errors, message } = response.data;
        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          await this.getCategories();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.reorder_mode = false;
        this.loading = false;
        this.$emit("toggle-reorder-mode", false);
      }
    },

    async openModifyCategory(category_id) {
      this.current_category_id = category_id;
      this.$bvModal.show("modify_category");
    },

    async openNewQuestion(category_id) {
      this.current_category_id = category_id;
      this.$bvModal.show("new_question");
    },

    async openModifyQuestion(category_id, question_id) {
      this.current_category_id = category_id;
      this.current_question_id = question_id;
      this.$bvModal.show("modify_question");
    },

    async openModifyAlternative(category_id, question_id, alternative_id) {
      this.current_category_id = category_id;
      this.current_question_id = question_id;
      this.current_alternative_id = alternative_id;
      this.$bvModal.show("modify_alternative");
    },

    allowReorderMode() {
      if (this.categories.length > 1) return true;

      for (const category of this.categories) {
        if (category.questions === undefined) return false;
        if (category.questions.length > 1) return true;

        return category.questions.some(
          (question) => question.alternatives.length > 1
        );
      }
    },
  },
};
</script>

<style escoped>
.switch-modern {
  position: relative;
  display: inline-block;
  width: 64px;
  height: 34px;
  cursor: pointer;
}

.switch-modern input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider-modern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #cbd5e1;
  border-radius: 34px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  padding: 2px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

.slider-thumb {
  width: 30px;
  height: 30px;
  background: white;
  border-radius: 50%;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transform: translateX(0);
}

.switch-modern input:checked + .slider-modern {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.switch-modern input:checked + .slider-modern .slider-thumb {
  transform: translateX(30px);
}

.switch-modern input:checked + .slider-modern .thumb-icon {
  color: #10b981;
}

.switch-modern input:disabled + .slider-modern {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>